import type { ValidationError } from '../types';
import { useRecoilValue } from 'recoil';
import { blockSettings } from 'venn-state';
import { useMemo } from 'react';
import { compact } from 'lodash';

export const useBlockValidation = (blockId: string): ValidationError[] => {
  const blockSetting = useRecoilValue(blockSettings(blockId));

  return useMemo(
    () =>
      compact([
        blockSetting.customBlockType === 'TAX_IMPACT' && {
          type: 'INFO' as const,
          message: 'The end date of the selected date range is used to calculate the Holding Period only.',
        },
      ]),
    [blockSetting.customBlockType],
  );
};
